__turbopack_context__.v({
  "fadeOut": "Overview-module-scss-module__vf6lhq__fadeOut",
  "hidden": "Overview-module-scss-module__vf6lhq__hidden",
  "readMore": "Overview-module-scss-module__vf6lhq__readMore",
  "report-event-wrapper": "Overview-module-scss-module__vf6lhq__report-event-wrapper",
  "summary": "Overview-module-scss-module__vf6lhq__summary",
  "summaryWrapper": "Overview-module-scss-module__vf6lhq__summaryWrapper",
  "title": "Overview-module-scss-module__vf6lhq__title",
});
